// ACTION TYPES
export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';
export const HIDE_GLOBAL_LOADER = 'HIDE_GLOBAL_LOADER';

// INITIAL STATE
const initialState = {
  isVisible: false,
  message: 'carregando...'
};

// REDUCER
function globalLoader(state = initialState, action) {
  switch (action.type) {
    case SHOW_GLOBAL_LOADER:
      return {
        ...state,
        isVisible: true,
        message: action.message || state.message
      };
    default:
      return {
        ...initialState
      }
  }
}

// ACTION CREATORS
export function showGlobalLoader(message) {
  return {type: SHOW_GLOBAL_LOADER, message};
}

export function hideGlobalLoader() {
  return {type: HIDE_GLOBAL_LOADER};
}

export default globalLoader;
